
import { DatePipe } from "@angular/common";
import { FormControl, FormGroup, Validators } from "@angular/forms";


export class CategoryModel {
    id : string;
    code : string;
    name : string;
    description: string;
    displayOrder : number;
    createBy: string;
    createTime : DatePipe;

    public static getFormGroup()
    {
         var form: FormGroup = new FormGroup({
        id: new FormControl(null),
        name: new FormControl(null, Validators.required),
        code: new FormControl(null),
        description :  new FormControl(null),
        displayOrder: new FormControl(0),
        createBy: new FormControl(null),
        createTime: new FormControl(null)    
        });
        return form;
    }

    public static initializeFormGroup(form){
 
        form.setValue({
         id : null,
         name : null,
         code: null,
         description:null,
         displayOrder : 0,
         createBy: null,
         createTime : null,
        });
      
      }
}
